import React from 'react';

/**
 * AdminAlert
 * 
 * Standardized alert/banner component for admin pages.
 * Uses CSS variables for colors (source of truth: clc.css)
 * 
 * @param {string} type - Alert type: 'success' | 'error' | 'info' | 'warn'
 * @param {string|ReactNode} message - Alert message
 * @param {function} onClose - Optional close handler
 * @param {boolean} dismissible - Whether alert can be dismissed
 */
export default function AdminAlert({ type = 'info', message, onClose, dismissible = false }) {
  const isDismissible = dismissible && onClose;
  
  // Map type to CSS class (matches admin-ui.css)
  const typeClassMap = {
    success: 'admin-alert-success',
    error: 'admin-alert-error',
    info: 'admin-alert-info',
    warn: 'admin-alert-warning',
    warning: 'admin-alert-warning',
  };
  
  const typeClass = typeClassMap[type] || 'admin-alert-info';

  return (
    <div
      className={`admin-alert ${typeClass}`}
      role="alert"
      aria-live="polite"
    >
      <div className="admin-alert-message">
        {message}
      </div>
      {isDismissible && (
        <button
          onClick={onClose}
          className="admin-alert-dismiss"
          type="button"
          aria-label="Close alert"
        >
          ×
        </button>
      )}
    </div>
  );
}

